import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from './supabaseClient'; // Assicurati che questo percorso sia corretto
import { useNavigate } from 'react-router-dom';
import './tailwind.css'; // Per gli stili di Tailwind CSS
import { generaPdfPolizza } from './utils/generatePolizzaPdf.ts';

// Icone utili per il form
import { FaCalculator, FaFileInvoice, FaUser, FaCalendarAlt, FaEuroSign, FaStickyNote, FaSave, FaTimes, FaSpinner, FaCar, FaMotorcycle, FaTruck, FaTag, FaCheckCircle, FaBuilding, FaIdCard, FaReceipt, FaSearch } from 'react-icons/fa'; // Aggiunte icone per azienda, codice fiscale, partita IVA, search

export default function NuovaPolizza() {
  const navigate = useNavigate();

  // Stati per i dati del form della polizza
  const [policyData, setPolicyData] = useState({
    // Cliente Privato / Azienda
    cliente_privato: true,      // NUOVO CAMPO: true per privato, false per azienda
    nome_cliente: '',           // Campo libero (nullable)
    cognome_cliente: '',        // Campo libero (nullable)
    ragione_sociale: '',       // NUOVO CAMPO: Campo libero (nullable)
    codice_fiscale: '',        // NUOVO CAMPO: Campo libero (nullable)
    partita_iva: '',           // NUOVO CAMPO: Campo libero (nullable)

    tipo_operazione: 'Nuovo Inserimento',        // Dropdown (Nuovo Inserimento / Rinnovo)
    tipologia_veicolo: 'Autovettura uso proprio',      // Dropdown (Moto / Autovettura uso proprio / Autocarro uso proprio)
    modello_auto: '',           // Campo libero
    data_immatricolazione: '',  // Datepicker
    targa: '',                  // Campo libero con validazione
    inizio_decorrenza: '',      // Datepicker con validazione
    fine_decorrenza: '',        // Datepicker con default e validazione
    id_pacchetto_garanzia: '',  // Dropdown
    valore_polizza_calcolato: 0, // Campo autocompilato e read-only
    note: ''
  });

  // Stati per le opzioni dei dropdown
  const [pacchettiGaranziaOptions, setPacchettiGaranziaOptions] = useState([]);

  // Stati per il caricamento e i messaggi di feedback
  const [isLoading, setIsLoading] = useState(true); // Indica caricamento generale (es. dati iniziali, verifica targa)
  const [isSubmitting, setIsSubmitting] = useState(false); // Indica caricamento per il submit del form
  
  // feedbackMessage è ora usato solo per messaggi generici, non più per la targa specifica
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [isErrorFeedback, setIsErrorFeedback] = useState(false);

  // Stati per la modale di conferma (per errori bloccanti o azioni di conferma)
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalMessage, setModalMessage] = useState('');
  const [modalCallback, setModalCallback] = useState(null); // Funzione da eseguire al click di 'OK' nella modale
const [justCreatedPolicy, setJustCreatedPolicy] = useState(null);

  // Stato per l'ID dell'utente autenticato (l'agente che crea la polizza)
  const [userId, setUserId] = useState(null);

  // ⭐ Nuovo stato per la verifica della targa ⭐
  const [isTargaVerified, setIsTargaVerified] = useState(false);

  // ⭐ Nuovi stati per la logica di rinnovo (punto 4) ⭐
  const [targaRicercaRinnovo, setTargaRicercaRinnovo] = useState('');
  const [targaSearchResults, setTargaSearchResults] = useState([]); // Per i risultati della ricerca Ajax
  const [isSearchingTargaForRenewal, setIsSearchingTargaForRenewal] = useState(false);
  const [noRenewalSearchResults, setNoRenewalSearchResults] = useState(false); // Stato per il messaggio "Nessuna polizza trovata"


  // Calcola le date minime e massime per il datepicker di Inizio Decorrenza
  const today = new Date();
  const year = today.getFullYear();
  const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Mesi sono 0-indexed
  const day = today.getDate().toString().padStart(2, '0');
  const minDateString = `${year}-${month}-${day}`; // FormatoYYYY-MM-DD per 'min' attributo

  const maxDateForInizioDecorrenza = new Date(today);
  maxDateForInizioDecorrenza.setMonth(maxDateForInizioDecorrenza.getMonth() + 4);
  const maxYear = maxDateForInizioDecorrenza.getFullYear();
  const maxMonth = (maxDateForInizioDecorrenza.getMonth() + 1).toString().padStart(2, '0');
  const maxDay = maxDateForInizioDecorrenza.getDate().toString().padStart(2, '0');
  const maxDateString = `${maxYear}-${maxMonth}-${maxDay}`; // FormatoYYYY-MM-DD per 'max' attributo


  // Funzione per mostrare feedback temporaneo (non bloccante)
  const showFeedback = useCallback((message, isErrorStatus = false) => {
    setFeedbackMessage(message);
    setIsErrorFeedback(isErrorStatus);
    const timer = setTimeout(() => {
      setFeedbackMessage('');
      setIsErrorFeedback(false);
    }, 4000); // Messaggio scompare dopo 4 secondi
    return () => clearTimeout(timer);
  }, []);

  // Funzione per aprire la modale di conferma (bloccante)
  // `onOkCallback` è la funzione che verrà eseguita se l'utente clicca 'OK'.
  // Se `onOkCallback` è null, il bottone 'OK' si limiterà a chiudere la modale.
  const openConfirmModal = useCallback((title, message, onOkCallback = null) => {
    setModalTitle(title);
    setModalMessage(message);
    setModalCallback(() => onOkCallback);
    setShowConfirmModal(true);
  }, []);

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
    setModalCallback(null); // Resetta il callback
  };

  // Funzione per resettare l'intero modulo
  const resetForm = useCallback(() => {
    setPolicyData(prev => ({ // Usa il prev state per mantenere alcuni valori di default
        cliente_privato: true, // Default a privato
        nome_cliente: '',
        cognome_cliente: '',
        ragione_sociale: '',
        codice_fiscale: '',
        partita_iva: '',
        tipo_operazione: 'Nuovo Inserimento',
        tipologia_veicolo: 'Autovettura uso proprio',
        modello_auto: '',
        data_immatricolazione: '',
        targa: '',
        inizio_decorrenza: '',
        fine_decorrenza: '',
        id_pacchetto_garanzia: pacchettiGaranziaOptions.length > 0 ? pacchettiGaranziaOptions[0].id : '',
        valore_polizza_calcolato: 0,
        note: ''
    }));
    setFeedbackMessage(''); // Pulisce anche eventuali feedback non modali
    setIsErrorFeedback(false);
    setIsTargaVerified(false); // Resetta lo stato di verifica targa al reset del form
    setTargaRicercaRinnovo(''); // Resetta il campo di ricerca targa per rinnovo
    setTargaSearchResults([]); // Resetta i risultati della ricerca Ajax
    setIsSearchingTargaForRenewal(false); // Resetta lo stato di ricerca
    setNoRenewalSearchResults(false); // Resetta lo stato del messaggio "Nessuna polizza trovata"
  }, [pacchettiGaranziaOptions]); // Dipendenza necessaria per impostare il default corretto di id_pacchetto_garanzia


  // --- Fetching dei Dati Iniziali (Pacchetti Garanzia, Utente) ---
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        // 1. Ottieni l'utente autenticato
        const { data: { user }, error: userError } = await supabase.auth.getUser();
        if (userError) throw userError;
        if (!user) {
          openConfirmModal('Autenticazione Richiesta', 'Utente non autenticato. Sarai reindirizzato alla pagina di login.', () => navigate('/'));
          return;
        }
        setUserId(user.id);

        // 2. Recupera i pacchetti garanzia attivi
        const { data: pacchettiData, error: pacchettiError } = await supabase
          .from('pacchetti_garanzia')
          .select('id, nome, valore_base')
          .eq('attivo', true) // Solo pacchetti attivi
          .order('ordine', { ascending: true }); // Ordina per ordine

        if (pacchettiError) throw pacchettiError;
        setPacchettiGaranziaOptions(pacchettiData);

        // Imposta i valori di default per i dropdown se ci sono opzioni
        setPolicyData(prev => ({
          ...prev,
          tipo_operazione: 'Nuovo Inserimento', // Default fisso
          tipologia_veicolo: 'Autovettura uso proprio', // Default fisso
          id_pacchetto_garanzia: pacchettiData.length > 0 ? pacchettiData[0].id : '',
          // Assicurati che i campi cliente/azienda siano correttamente inizializzati
          cliente_privato: true, // Default a privato
          nome_cliente: '',
          cognome_cliente: '',
          ragione_sociale: '',
          codice_fiscale: '',
          partita_iva: ''
        }));

      } catch (err) {
        console.error('Errore nel caricamento dei dati iniziali:', err.message);
        openConfirmModal('Errore di Caricamento', `Impossibile caricare i dati iniziali: ${err.message}. Ricaricare la pagina o contattare l'assistenza.`);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [navigate, openConfirmModal]); // Dipendenze: navigate e openConfirmModal

  const handleDownloadPdf = async (policy) => {
      try {
        const blob = await generaPdfPolizza(policy.id);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `polizza_${policy.numero_polizza ?? policy.id}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
      } catch (err) {
        // Non usare alert(), usa la modale di conferma
        openConfirmModal('Errore PDF', `Si è verificato un errore durante la generazione del PDF: ${err.message}.`);
      }
    };

  // --- Gestione Cambiamenti Input del Form ---
  const handleInputChange = (e) => {
    const { name, value, type } = e.target; // Rimosso 'checked' perché non usato direttamente qui per i radio

    setPolicyData(prev => {
      let newState = { ...prev };

      // Logica per il campo "Tipologia Cliente" (radio button)
      if (name === 'cliente_tipologia_radio') { // Nuovo nome per il radio group
        newState.cliente_privato = value === 'PRIVATO'; // Se 'PRIVATO', allora true, altrimenti false
        // Resetta i campi pertinenti quando si cambia tipo di cliente
        if (newState.cliente_privato) { // Se diventa Privato
          newState.ragione_sociale = '';
          newState.partita_iva = '';
          // Il codice fiscale rimane perché è visibile solo per i privati
          // e non dovrebbe essere azzerato se si torna a privato
        } else { // Se diventa Azienda / Libero Professionista
          newState.nome_cliente = '';
          newState.cognome_cliente = '';
          newState.codice_fiscale = ''; // ⭐ Azzeriamo il codice fiscale se si passa ad Azienda ⭐
        }
      } 
      // Logica per il cambio di tipo_operazione
      else if (name === 'tipo_operazione') {
        newState[name] = value;
        // Se si cambia il tipo operazione, resetta la ricerca targa del rinnovo e i risultati
        if (value !== 'Rinnovo') {
          setTargaRicercaRinnovo('');
          setTargaSearchResults([]); // Pulisce i risultati della ricerca Ajax
          setIsSearchingTargaForRenewal(false); // Resetta lo stato di ricerca
          setNoRenewalSearchResults(false); // Resetta lo stato del messaggio "Nessuna polizza trovata"

          // Anche azzerare i campi precompilati se non si è più in modalità rinnovo
          // Mantiene solo le date e il pacchetto se erano stati scelti manualmente, altrimenti azzera
          newState = {
            ...newState,
            modello_auto: '',
            data_immatricolazione: '',
            targa: '',
            // Lascia inizio_decorrenza e fine_decorrenza se sono state inserite manualmente, altrimenti azzera.
            // O azzerale sempre se esci dalla modalità rinnovo e non sono state impostate manualmente.
            // Per semplicità qui, azzeriamo solo la targa e i campi dell'auto se esce dal rinnovo
            // e non sono stati modificati manualmente.
            // Inizio e fine decorrenza sono lasciati intatti per permettere la scelta manuale.
          };
        } else {
            // Se si passa a "Rinnovo", azzera lo stato di verifica targa della sezione "Nuovo Inserimento"
            setIsTargaVerified(false);
        }
      }
      else {
        newState[name] = type === 'number' ? parseFloat(value) || 0 : value;
      }
      
      // Se il campo targa cambia (dal form normale), resetta lo stato di verifica
      if (name === 'targa') {
        setIsTargaVerified(false); 
      }

      // Se cambia la data di inizio decorrenza, azzera la data di fine e ricalcola il default
      if (name === 'inizio_decorrenza') { 
        const startDate = new Date(value);
        if (value && !isNaN(startDate.getTime())) { 
          const defaultEndDate = new Date(startDate);
          defaultEndDate.setFullYear(defaultEndDate.getFullYear() + 1); 
          // Nessuna modifica qui, la data sarà già lo stesso giorno dell'anno successivo
          // defaultEndDate.setDate(defaultEndDate.getDate()); // O lasciare così se si vuole essere espliciti

          newState = {
            ...newState,
            fine_decorrenza: defaultEndDate.toISOString().split('T')[0] 
          };
        } else {
            // Se inizio_decorrenza viene svuotato, anche fine_decorrenza deve essere svuotato
            newState = {
                ...newState,
                fine_decorrenza: ''
            };
        }
      }
      return newState;
    });
  };

  // ⭐ Funzione per la ricerca della targa per il rinnovo (debounced) ⭐
  useEffect(() => {
    const searchTargaForRenewal = async () => {
      const targa = targaRicercaRinnovo.trim().toUpperCase();
      if (targa.length < 3) { // Inizia la ricerca solo dopo 3 caratteri per efficienza
        setTargaSearchResults([]);
        setIsSearchingTargaForRenewal(false);
        setNoRenewalSearchResults(false); // Resetta il messaggio se la ricerca è troppo breve
        return;
      }

      setIsSearchingTargaForRenewal(true);
      setNoRenewalSearchResults(false); // Resetta il messaggio all'inizio di una nuova ricerca
      try {
        // Cerca polizze che contengono la targa parziale
        const { data, error } = await supabase
          .from('polizze')
          .select('id, numero_polizza, targa, cliente_privato, nome_cliente, cognome_cliente, ragione_sociale, fine_decorrenza, stato_polizza')
          .ilike('targa', `%${targa}%`) // Ricerca LIKE per targa parziale
          .order('fine_decorrenza', { ascending: false }) // Ordina dalla più recente per scadenza
          .limit(10); // Limita i risultati per performance

        if (error && error.code !== 'PGRST116') { // PGRST116 = nessun record trovato
          throw error;
        }

        setTargaSearchResults(data || []); // Se nessun dato, imposta a array vuoto
        if (!data || data.length === 0) {
            setNoRenewalSearchResults(true); // Imposta il flag se non ci sono risultati
        } else {
            setNoRenewalSearchResults(false);
        }
        showFeedback('', false); // Pulisce feedback precedenti

      } catch (err) {
        console.error('Errore durante la ricerca targa per rinnovo:', err.message);
        showFeedback(`Errore durante la ricerca targa: ${err.message}.`, true);
        setTargaSearchResults([]);
        setNoRenewalSearchResults(true); // Imposta il flag anche in caso di errore di ricerca
      } finally {
        setIsSearchingTargaForRenewal(false);
      }
    };

    const handler = setTimeout(() => {
      searchTargaForRenewal();
    }, 500); // Debounce di 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [targaRicercaRinnovo, showFeedback]);

  // ⭐ Funzione per selezionare una polizza dai risultati di ricerca del rinnovo ⭐
  const handleSelectPolicyForRenewal = useCallback(async (selectedPolicyId) => {
    setIsSearchingTargaForRenewal(true); // Attiva loader temporaneamente per il pre-riempimento
    try {
        const { data, error } = await supabase
            .from('polizze')
            .select('*') // Seleziona tutti i campi per precompilare
            .eq('id', selectedPolicyId)
            .single();

        if (error) throw error;

        // Precompila il form, lasciando vuoti inizio_decorrenza e fine_decorrenza
        setPolicyData(prev => ({
            ...prev,
            cliente_privato: data.cliente_privato,
            nome_cliente: data.nome_cliente || '',
            cognome_cliente: data.cognome_cliente || '',
            ragione_sociale: data.ragione_sociale || '',
            codice_fiscale: data.codice_fiscale || '',
            partita_iva: data.partita_iva || '',
            
            // Assicurati che tipo_operazione sia 'Rinnovo'
            tipo_operazione: 'Rinnovo',
            tipologia_veicolo: data.tipologia_veicolo || '',
            modello_auto: data.modello_auto || '',
            data_immatricolazione: data.data_immatricolazione || '',
            targa: data.targa || '',
            inizio_decorrenza: '', // Lasciato VUOTO come richiesto
            fine_decorrenza: '',   // Lasciato VUOTO come richiesto
            id_pacchetto_garanzia: data.id_pacchetto_garanzia || (pacchettiGaranziaOptions.length > 0 ? pacchettiGaranziaOptions[0].id : ''),
            valore_polizza_calcolato: 0, // Reset per ricalcolo
            note: data.note || ''
        }));
        setTargaSearchResults([]); // Pulisce i risultati dopo la selezione
        setNoRenewalSearchResults(false); // ⭐ Importante: resetta il flag quando si seleziona ⭐
        setIsTargaVerified(true); // La targa della polizza precompilata è considerata verificata
        showFeedback(`Dati della polizza N. ${data.numero_polizza || data.id.substring(0,8)} precompilati per il rinnovo. Inserisci le nuove date di decorrenza.`, false);

    } catch (err) {
        console.error('Errore nel caricamento dati polizza per rinnovo:', err.message);
        openConfirmModal('Errore Precompilazione', `Impossibile caricare i dati della polizza selezionata: ${err.message}.`);
        setIsTargaVerified(false);
    } finally {
        setIsSearchingTargaForRenewal(false);
    }
  }, [openConfirmModal, showFeedback, pacchettiGaranziaOptions]);


  // ⭐ Nuova funzione per il calcolo preciso dei mesi ⭐
  const calculateMonthsPrecise = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || startDate > endDate) {
        return 0; // Se le date non sono valide o inizio > fine, restituisce 0
    }

    const sYear = startDate.getFullYear();
    const sMonth = startDate.getMonth(); // 0-indexed
    const sDay = startDate.getDate();

    const eYear = endDate.getFullYear();
    const eMonth = endDate.getMonth(); // 0-indexed
    const eDay = endDate.getDate();

    // Calcola la differenza di mesi completa (ignorando il giorno per ora)
    let months = (eYear - sYear) * 12 + (eMonth - sMonth);

    // Regola l'arrotondamento in base al giorno di inizio e fine
    // Se il giorno di fine è minore o uguale al giorno di inizio, significa che
    // l'anniversario del mese non è ancora stato raggiunto (o è lo stesso giorno),
    // quindi sottraiamo un mese se non è il giorno successivo esatto.
    if (eDay <= sDay && !(eYear === sYear && eMonth === sMonth && eDay === sDay + 1)) {
        months--;
    }

    // Se la durata è esattamente 0 giorni, restituisce 0 mesi.
    if (endDate.getTime() === startDate.getTime()) {
      return 0;
    }

    // Se la durata è maggiore di 0 giorni, ma il calcolo iniziale dei mesi è 0,
    // significa che siamo all'interno del primo mese. In questo caso, conta come 1 mese.
    if (months === 0 && endDate.getTime() > startDate.getTime()) {
        return 1;
    }
    
    // Per tutti gli altri casi, se c'è una durata positiva, aggiungi 1 per l'arrotondamento per eccesso
    // (una frazione del mese successivo conta come un mese intero).
    if (months >= 0 && endDate.getTime() > startDate.getTime()) {
      return months + 1;
    }
    
    return months; // Per altri casi, es. date invalide già catturate all'inizio
};


  // --- Validazione e Calcolo del Premio (useEffect) ---
  useEffect(() => {
    const calculatePolicyValue = () => {
      const { inizio_decorrenza, fine_decorrenza, id_pacchetto_garanzia } = policyData;

      const selectedPackage = pacchettiGaranziaOptions.find(p => p.id === id_pacchetto_garanzia);

      if (!selectedPackage || !inizio_decorrenza || !fine_decorrenza) {
        setPolicyData(prev => ({ ...prev, valore_polizza_calcolato: 0 }));
        return;
      }

      const baseValue = parseFloat(selectedPackage.valore_base);
      const startDate = new Date(inizio_decorrenza);
      const endDate = new Date(fine_decorrenza);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime()) || startDate > endDate) {
        setPolicyData(prev => ({ ...prev, valore_polizza_calcolato: 0 }));
        return;
      }

      // ⭐ Utilizza la nuova funzione di calcolo mesi ⭐
      let effectiveMonths = calculateMonthsPrecise(inizio_decorrenza, fine_decorrenza);

      // Assicurati che il minimo sia 1 mese per una polizza valida se la durata è > 0 giorni
      if (effectiveMonths < 1 && (endDate.getTime() > startDate.getTime())) {
          effectiveMonths = 1; 
      }
      
      const monthlyBase   = baseValue / 12;          // quota mensile
const calculatedValue = monthlyBase * Math.min(effectiveMonths, 14);

      setPolicyData(prev => ({ ...prev, valore_polizza_calcolato: parseFloat(calculatedValue.toFixed(2)) }));
    };

    calculatePolicyValue();
  }, [policyData.inizio_decorrenza, policyData.fine_decorrenza, policyData.id_pacchetto_garanzia, pacchettiGaranziaOptions]);


  // --- Funzione per la Verifica della Targa (con bottone e popup unico) ---
  // Questa è la verifica per NUOVO INSERIMENTO. La logica di "Rinnovo" è separata.
  // --- Funzione per la Verifica della Targa (con bottone e popup unico) ---
  // Questa è la verifica per NUOVO INSERIMENTO. La logica di "Rinnovo" è separata.
  const handleTargaVerification = useCallback(async () => {
    const targa = policyData.targa.trim().toUpperCase();
    setPolicyData(prev => ({ ...prev, targa: targa })); // Normalizza la targa

    let messages = []; // Array per accumulare i messaggi del popup
    let isErrorDuringCheck = false; // Indica se c'è un errore di sistema durante la verifica

    if (targa.length === 0) {
        openConfirmModal('Verifica Targa', 'Il campo Targa non può essere vuoto per la verifica.');
        setIsTargaVerified(false);
        return;
    }

    // 1. Validazione lunghezza
    if (targa.length !== 7) {
        messages.push('La targa inserita non ha esattamente 7 caratteri. Questo potrebbe indicare una targa estera o un errore di digitazione. Verificare prima di continuare.');
    }

    // 2. Validazione esistenza e stato
    setIsLoading(true); // Attiva il loader per il controllo del DB (temporaneo per il controllo targa)
    try {
        // Modifica qui: non usare .single(), ordina per data di creazione e includi numero_polizza
        const { data: policiesFound, error } = await supabase
            .from('polizze')
            .select('stato_polizza, fine_decorrenza, created_at, numero_polizza') // Includi created_at e numero_polizza
            .eq('targa', targa)
            .order('created_at', { ascending: false }); // Ordina dalla più recente per data di creazione

        if (error && error.code !== 'PGRST116') { // PGRST116 = nessun record trovato
            throw error; // Propaga l'errore per gestirlo nel catch
        }

        if (policiesFound && policiesFound.length > 0) {
            const activePolicies = policiesFound.filter(p => p.stato_polizza === 'ATTIVA');

            if (activePolicies.length > 1) {
                // Trovate più polizze ATTIVE
                const mostRecentActive = activePolicies[0]; // È già la più recente grazie all'ordinamento
                messages.push(`Attenzione: Sono state trovate ${activePolicies.length} adesioni ATTIVE con questa targa.
La più recente è la Adesione N. ${mostRecentActive.numero_polizza || mostRecentActive.id.substring(0,8)} con Fine Decorrenza: ${mostRecentActive.fine_decorrenza}.
Si prega di verificare prima di continuare.`);
            } else if (activePolicies.length === 1) {
                // Trovata una singola polizza ATTIVA
                const singleActivePolicy = activePolicies[0];
                messages.push(`Attenzione: Esiste già una adesione ATTIVA con questa targa.
Adesione N. ${singleActivePolicy.numero_polizza || singleActivePolicy.id.substring(0,8)}
Stato: ${singleActivePolicy.stato_polizza}
Fine Decorrenza: ${singleActivePolicy.fine_decorrenza}
Si prega di verificare prima di continuare.`);
            } else {
                // Trovate polizze ma nessuna è ATTIVA (es. tutte SCADUTE o altri stati)
                messages.push(`Attenzione: Sono state trovate adesioni con questa targa, ma nessuna è ATTIVA.
Si prega di verificare lo storico delle adesioni per maggiori dettagli.`);
            }
        }
    } catch (err) {
        console.error('Errore nel controllo targa:', err.message);
        messages.push(`Errore di sistema durante la verifica della targa: ${err.message}. Riprovare.`);
        isErrorDuringCheck = true;
    } finally {
        setIsLoading(false); // Disattiva il loader
    }

    // Mostra un popup unico con tutti i messaggi accumulati
    if (messages.length > 0) {
        const title = isErrorDuringCheck ? 'Errore Critico Targa' : 'Verifica Targa';
        // Passa null come callback per non resettare il form
        openConfirmModal(title, messages.join('\n\n'), null);
        setIsTargaVerified(true); // La verifica è stata eseguita, anche se con avvisi
    } else {
        // Se tutto è OK e non ci sono avvisi, mostra un feedback positivo e setta verificato
        showFeedback('Targa verificata con successo: nessuna targa esistente o problemi di lunghezza rilevati.', false);
        setIsTargaVerified(true); // Targa verificata con successo
    }
  }, [policyData.targa, openConfirmModal, showFeedback]);


  // --- Validazione Date Inizio/Fine Decorrenza ---
  const validateDates = useCallback(() => {
    const { inizio_decorrenza, fine_decorrenza } = policyData;
    const currentToday = new Date();
    currentToday.setHours(0, 0, 0, 0);

    let startDate = null;
    let endDate = null;

    if (inizio_decorrenza) {
      startDate = new Date(inizio_decorrenza);
      startDate.setHours(0, 0, 0, 0);

      if (startDate < currentToday) {
        openConfirmModal('Data Invalida', 'La Data Inizio Decorrenza non può essere precedente alla data odierna.');
        return false;
      }

      const maxAllowedStartDate = new Date(currentToday);
      maxAllowedStartDate.setMonth(maxAllowedStartDate.getMonth() + 4);
      maxAllowedStartDate.setDate(maxAllowedStartDate.getDate());
      if (startDate > maxAllowedStartDate) {
        openConfirmModal('Data Invalida', 'La Data Inizio Decorrenza non può essere successiva a 4 mesi dalla data odierna.');
        return false;
      }
    }

    if (fine_decorrenza) {
      endDate = new Date(fine_decorrenza);
      endDate.setHours(0, 0, 0, 0);

      if (startDate && endDate) {
        const maxAllowedEndDate = new Date(startDate);
        maxAllowedEndDate.setFullYear(startDate.getFullYear() + 1);
        maxAllowedEndDate.setMonth(maxAllowedEndDate.getMonth() + 1); // Aggiungi un mese
        
        if (endDate > maxAllowedEndDate) {
          openConfirmModal('Data Invalida', 'La Data Fine Decorrenza non può essere superiore a un anno e un mese dalla Data Inizio.');
          return false;
        }

        const minAllowedEndDate = new Date(startDate);
        minAllowedEndDate.setMonth(minAllowedEndDate.getMonth() + 2);
        if (endDate < minAllowedEndDate) {
          openConfirmModal('Data Invalida', 'La Data Fine Decorrenza non può essere inferiore a due mesi dalla Data Inizio.');
          return false;
        }
      }
    }
    return true;
  }, [policyData.inizio_decorrenza, policyData.fine_decorrenza, openConfirmModal]);


  // --- Gestione Submit del Form ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting || isLoading || !userId) return;

    // Controllo obbligatorio verifica targa
    if (!isTargaVerified) {
        openConfirmModal('Verifica Targa Obbligatoria', 'Si prega di verificare la targa prima di procedere con l\'invio del modulo.');
        return;
    }

    // Esegui tutte le validazioni critiche qui prima di inviare
    if (!validateDates()) {
      return;
    }

    // Validazione campi obbligatori cliente/azienda
    if (policyData.cliente_privato) { // Cliente Privato
      if (!policyData.nome_cliente || !policyData.cognome_cliente) {
        openConfirmModal('Campi Mancanti', 'Per i clienti privati, Nome e Cognome sono obbligatori.');
        return;
      }
      if (policyData.codice_fiscale && policyData.codice_fiscale.length !== 16) {
        openConfirmModal('Formato Codice Fiscale', 'Il Codice Fiscale deve avere esattamente 16 caratteri alfanumerici.');
        return;
      } else if (!policyData.codice_fiscale) { // Se è privato, il codice fiscale è opzionale, ma se c'è deve essere valido
        // Nessun errore se è vuoto
      }
    } else { // Azienda / Libero Professionista
      if (!policyData.ragione_sociale || !policyData.ragione_sociale.trim() || !policyData.partita_iva || !policyData.partita_iva.trim()) {
        openConfirmModal('Campi Mancanti', 'Per le aziende/liberi professionisti, Ragione Sociale e Partita IVA sono obbligatori.');
        return;
      }
      if (policyData.partita_iva.length !== 11 || !/^\d+$/.test(policyData.partita_iva)) {
        openConfirmModal('Formato Partita IVA', 'La Partita IVA deve avere esattamente 11 cifre numeriche.');
        return;
      }
      // Codice fiscale non è più presente se si sceglie Azienda/Libero Professionista, quindi non serve validarlo qui.
    }

    // Validazione generale dei campi obbligatori comuni
    if (!policyData.tipo_operazione || !policyData.tipologia_veicolo || !policyData.targa || !policyData.targa.trim() ||
        !policyData.inizio_decorrenza || !policyData.fine_decorrenza ||
        !policyData.id_pacchetto_garanzia || policyData.valore_polizza_calcolato <= 0) {
      openConfirmModal('Campi Mancanti', 'Si prega di compilare tutti i campi obbligatori e assicurarsi che il valore della polizza sia calcolato.');
      return;
    }

    setIsSubmitting(true);
    showFeedback('', false); // Resetta feedback precedenti

    try {
      // Prepara i dati per l'inserimento, impostando a null i campi non pertinenti
      const dataToInsert = {
        id_agente: userId,
        tipo_operazione: policyData.tipo_operazione,
        tipologia_veicolo: policyData.tipologia_veicolo,
        modello_auto: policyData.modello_auto || null,
        data_immatricolazione: policyData.data_immatricolazione || null,
        targa: policyData.targa,
        inizio_decorrenza: policyData.inizio_decorrenza,
        fine_decorrenza: policyData.fine_decorrenza,
        id_pacchetto_garanzia: policyData.id_pacchetto_garanzia,
        valore_polizza_calcolato: policyData.valore_polizza_calcolato,
        stato_polizza: 'ATTIVA',
        note: policyData.note || null,
        
        // Nuovi campi cliente/azienda
        cliente_privato: policyData.cliente_privato,
        // Codice fiscale solo se cliente privato
        codice_fiscale: policyData.cliente_privato ? policyData.codice_fiscale || null : null, 

        // Campi condizionali (imposta a null se non pertinenti)
        nome_cliente: policyData.cliente_privato ? policyData.nome_cliente : null,
        cognome_cliente: policyData.cliente_privato ? policyData.cognome_cliente : null,
        ragione_sociale: !policyData.cliente_privato ? policyData.ragione_sociale : null,
        partita_iva: !policyData.cliente_privato ? policyData.partita_iva : null,
      };

      // 1. Inserisci la nuova polizza nel database SENZA il numero_polizza (che sarà generato dopo)
      const { data: newPolicy, error: insertError } = await supabase
    .from('polizze')
    .insert(dataToInsert)
    .select('id, numero_polizza') // 👈 importante: così il DB ti restituisce anche il numero generato
    .single();

  if (insertError) throw insertError;

setJustCreatedPolicy(newPolicy);
openConfirmModal('Polizza Creata!', `La Polizza N. ${newPolicy.numero_polizza} è stata creata con successo! Puoi scaricare ora il PDF.`, null);

      
      // Non resettare il form qui, il resetForm() è chiamato solo dopo la chiusura della modale
      // per permettere il download del PDF.

    } catch (err) {
      console.error('Errore durante la creazione della polizza:', err.message);
      openConfirmModal('Errore di Creazione', `Si è verificato un errore durante la creazione della polizza: ${err.message}.`, null); // Solo OK
    } finally {
      setIsSubmitting(false);
    }
  };

  // Calcola le date minime e massime per il datepicker di Fine Decorrenza
  let minFineDateString = '';
  let maxFineDateString = '';

  if (policyData.inizio_decorrenza) {
    const startDate = new Date(policyData.inizio_decorrenza);
    
    // Data minima: 2 mesi da inizio_decorrenza
    const minFineDate = new Date(startDate);
    minFineDate.setMonth(minFineDate.getMonth() + 2);
    if (minFineDate <= startDate) { // Assicura che la data minima sia sempre successiva a inizio_decorrenza
        minFineDate.setDate(startDate.getDate() + 1); 
    }
    minFineDateString = minFineDate.toISOString().split('T')[0];

    // ⭐ Data massima: 1 anno e 1 mese da inizio_decorrenza (stesso giorno) ⭐
    const maxFineDate = new Date(startDate);
    maxFineDate.setFullYear(maxFineDate.getFullYear() + 1);
    maxFineDate.setMonth(maxFineDate.getMonth() + 1); // Aggiungi un mese
    maxFineDateString = maxFineDate.toISOString().split('T')[0];
  }

  // --- Render del Componente ---
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50 text-slate-800">
        <FaSpinner className="animate-spin text-4xl text-mioblu mr-3" />
        <p className="text-xl font-semibold">Caricamento dati...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="bg-white p-8 rounded-lg shadow-xl w-full max-w-2xl lg:max-w-3xl">
        <h1 className="text-2xl md:text-3xl font-bold uppercase mb-6 text-center text-mioblu">
          Crea Nuova Adesione
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6">

          {/* Tipo Operazione (Dropdown) - SPOSTATO PIÙ IN ALTO */}
          <div>
            <label htmlFor="tipo_operazione" className="block text-sm font-medium text-gray-700 mb-1">
              Tipo Operazione <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaFileInvoice className="text-gray-400" />
              </span>
              <select
                id="tipo_operazione"
                name="tipo_operazione"
                value={policyData.tipo_operazione}
                onChange={handleInputChange}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm appearance-none bg-white"
              >
                <option value="Nuovo Inserimento">Nuovo Inserimento</option>
                <option value="Rinnovo">Rinnovo</option>
              </select>
            </div>
          </div>

          {/* ⭐ Sezione Rinnovo con ricerca targa ⭐ */}
          {policyData.tipo_operazione === 'Rinnovo' && (
            <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
              <h2 className="text-lg font-semibold text-blue-800 mb-3">Ricerca Adesione per Rinnovo</h2>
              <div className="relative flex items-stretch">
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <FaSearch className="text-gray-400" />
                </span>
                <input
                  type="text"
                  id="targa_ricerca_rinnovo"
                  name="targa_ricerca_rinnovo"
                  value={targaRicercaRinnovo}
                  onChange={(e) => setTargaRicercaRinnovo(e.target.value)}
                  className="flex-grow pl-10 pr-3 py-2 border border-blue-300 rounded-l-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm uppercase"
                  placeholder="Inserisci targa per ricerca"
                  maxLength="10"
                />
                <button
                  type="button"
                  disabled={isSearchingTargaForRenewal || targaRicercaRinnovo.length < 3}
                  className="px-4 py-2 bg-blue-600 text-white rounded-r-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm flex-shrink-0"
                  onClick={() => { /* La ricerca avviene tramite useEffect debounced, il bottone è per feedback visivo */ }}
                >
                  {isSearchingTargaForRenewal ? <FaSpinner className="animate-spin" /> : <FaSearch />} Cerca
                </button>
              </div>

              {targaRicercaRinnovo.length >= 3 && targaSearchResults.length > 0 && (
                <div className="mt-3 p-3 bg-white border border-gray-200 rounded-md shadow-inner max-h-48 overflow-y-auto">
                  <p className="text-sm font-medium text-gray-700 mb-2">Seleziona una adesione:</p>
                  {targaSearchResults.map(policy => (
                    <button
                      key={policy.id}
                      type="button"
                      onClick={() => handleSelectPolicyForRenewal(policy.id)}
                      className="w-full text-left p-2 mb-1 text-sm rounded-md hover:bg-gray-100 transition-colors border-b border-gray-100 last:border-b-0"
                    >
                      <span className="font-semibold">{policy.numero_polizza || policy.id.substring(0,8)}</span> - {policy.targa} - ({policy.cliente_privato ? `${policy.nome_cliente || ''} ${policy.cognome_cliente || ''}` : policy.ragione_sociale || 'N/A'}) - Scadenza: {policy.fine_decorrenza} ({policy.stato_polizza})
                    </button>
                  ))}
                </div>
              )}
              {targaRicercaRinnovo.length >= 3 && !isSearchingTargaForRenewal && noRenewalSearchResults && (
                 <p className="mt-2 text-sm text-gray-500">Nessuna adesione trovata con questa targa.</p>
              )}
            </div>
          )}

          {/* Tipo di Cliente (Privato / Azienda) */}
          <div className="flex items-center space-x-4 mb-4">
            <span className="block text-sm font-medium text-gray-700">Tipologia Cliente: <span className="text-red-500">*</span></span>
            <div className="flex items-center">
              <input
                type="radio"
                id="cliente_privato_si"
                name="cliente_tipologia_radio" 
                value="PRIVATO"
                checked={policyData.cliente_privato === true}
                onChange={handleInputChange}
                className="focus:ring-miorosso h-4 w-4A text-miorosso border-gray-300"
              />
              <label htmlFor="cliente_privato_si" className="ml-2 block text-sm text-gray-900">
                Privato
              </label>
            </div>
            <div className="flex items-center">
              <input
                type="radio"
                id="cliente_privato_no"
                name="cliente_tipologia_radio"
                value="AZIENDA_LIBERO_PROFESSIONISTA"
                checked={policyData.cliente_privato === false}
                onChange={handleInputChange}
                className="focus:ring-miorosso h-4 w-4 text-miorosso border-gray-300"
              />
              <label htmlFor="cliente_privato_no" className="ml-2 block text-sm text-gray-900">
                Azienda / Libero Professionista
              </label>
            </div>
          </div>

          {/* Campi per Cliente Privato */}
          {policyData.cliente_privato ? (
            <>
              {/* Nome Cliente */}
              <div>
                <label htmlFor="nome_cliente" className="block text-sm font-medium text-gray-700 mb-1">
                  Nome Cliente <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FaUser className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    id="nome_cliente"
                    name="nome_cliente"
                    value={policyData.nome_cliente}
                    onChange={handleInputChange}
                    required // Obbligatorio per privato
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                    placeholder="Nome del cliente"
                  />
                </div>
              </div>

              {/* Cognome Cliente */}
              <div>
                <label htmlFor="cognome_cliente" className="block text-sm font-medium text-gray-700 mb-1">
                  Cognome Cliente <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FaUser className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    id="cognome_cliente"
                    name="cognome_cliente"
                    value={policyData.cognome_cliente}
                    onChange={handleInputChange}
                    required // Obbligatorio per privato
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                    placeholder="Cognome del cliente"
                  />
                </div>
              </div>

              {/* Codice Fiscale (per Privato) ⭐ SOLO PER PRIVATO ⭐ */}
              <div>
                <label htmlFor="codice_fiscale" className="block text-sm font-medium text-gray-700 mb-1">
                  Codice Fiscale
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FaIdCard className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    id="codice_fiscale"
                    name="codice_fiscale"
                    value={policyData.codice_fiscale}
                    onChange={handleInputChange}
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm uppercase"
                    placeholder="Codice Fiscale (16 caratteri)"
                    maxLength="16" // Max length per Codice Fiscale
                  />
                </div>
              </div>
            </>
          ) : (
            // Campi per Azienda / Libero Professionista ⭐ Nessun campo codice fiscale qui ⭐
            <>
              {/* Ragione Sociale */}
              <div>
                <label htmlFor="ragione_sociale" className="block text-sm font-medium text-gray-700 mb-1">
                  Ragione Sociale <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FaBuilding className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    id="ragione_sociale"
                    name="ragione_sociale"
                    value={policyData.ragione_sociale}
                    onChange={handleInputChange}
                    required // Obbligatorio per azienda
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                    placeholder="Ragione Sociale dell'azienda"
                  />
                </div>
              </div>

              {/* Partita IVA */}
              <div>
                <label htmlFor="partita_iva" className="block text-sm font-medium text-gray-700 mb-1">
                  Partita IVA <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                    <FaReceipt className="text-gray-400" />
                  </span>
                  <input
                    type="text"
                    id="partita_iva"
                    name="partita_iva"
                    value={policyData.partita_iva}
                    onChange={handleInputChange}
                    required // Obbligatorio per azienda
                    className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                    placeholder="Partita IVA (11 cifre)"
                    maxLength="11" // Esempio di max length per P.IVA italiana
                  />
                </div>
              </div>
            </>
          )}


          {/* Tipologia Veicolo (Dropdown) */}
          <div>
            <label htmlFor="tipologia_veicolo" className="block text-sm font-medium text-gray-700 mb-1">
              Tipologia Veicolo <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                {policyData.tipologia_veicolo === 'Moto' && <FaMotorcycle className="text-gray-400" />}
                {policyData.tipologia_veicolo === 'Autovettura uso proprio' && <FaCar className="text-gray-400" />}
                {policyData.tipologia_veicolo === 'Autocarro uso proprio' && <FaTruck className="text-gray-400" />}
                {!policyData.tipologia_veicolo && <FaCar className="text-gray-400" />} {/* Default icon */}
              </span>
              <select
                id="tipologia_veicolo"
                name="tipologia_veicolo"
                value={policyData.tipologia_veicolo}
                onChange={handleInputChange}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm appearance-none bg-white"
              >
                <option value="Autovettura uso proprio">Autovettura uso proprio</option>
                <option value="Moto">Moto</option>
                <option value="Autocarro uso proprio">Autocarro uso proprio</option>
              </select>
            </div>
          </div>

          {/* Modello Veicolo */}
          <div>
            <label htmlFor="modello_auto" className="block text-sm font-medium text-gray-700 mb-1">
              Modello Veicolo
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaCar className="text-gray-400" />
              </span>
              <input
                type="text"
                id="modello_auto"
                name="modello_auto"
                value={policyData.modello_auto}
                onChange={handleInputChange}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                placeholder="Es. Fiat Panda, Yamaha MT-07"
              />
            </div>
          </div>

          {/* Data Immatricolazione */}
          <div>
            <label htmlFor="data_immatricolazione" className="block text-sm font-medium text-gray-700 mb-1">
              Data Immatricolazione
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaCalendarAlt className="text-gray-400" />
              </span>
              <input
                type="date"
                id="data_immatricolazione"
                name="data_immatricolazione"
                value={policyData.data_immatricolazione}
                onChange={handleInputChange}
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
              />
            </div>
          </div>

          {/* Targa (con pulsante di verifica o read-only) */}
          <div>
            <label htmlFor="targa" className="block text-sm font-medium text-gray-700 mb-1">
              Targa <span className="text-red-500">*</span>
            </label>
            <div className="relative flex items-stretch"> 
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaTag className="text-gray-400" />
              </span>
              <input
                type="text"
                id="targa"
                name="targa"
                value={policyData.targa}
                onChange={handleInputChange}
                required
                readOnly={policyData.tipo_operazione === 'Rinnovo'} // ⭐ Read-only se è Rinnovo ⭐
                className={`flex-grow pl-10 pr-3 py-2 border border-gray-300 rounded-l-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm uppercase ${
                  policyData.tipo_operazione === 'Rinnovo' ? 'bg-gray-100 cursor-not-allowed rounded-r-md' : '' // Stile per read-only
                }`} 
                placeholder="Es. AA123BB"
                maxLength="10" 
              />
              {policyData.tipo_operazione === 'Nuovo Inserimento' && ( // ⭐ Bottone Verifica solo per Nuovo Inserimento ⭐
                <button
                  type="button"
                  onClick={handleTargaVerification}
                  disabled={isLoading}
                  className="px-4 py-2 bg-mioblu text-white rounded-r-md hover:bg-miobluhover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-mioblu disabled:opacity-50 disabled:cursor-not-allowed text-sm flex-shrink-0"
                >
                  {isLoading ? <FaSpinner className="animate-spin" /> : <FaCheckCircle className="mr-1" />} Verifica
                </button>
              )}
            </div>
          </div>

          {/* Inizio Decorrenza */}
          <div>
            <label htmlFor="inizio_decorrenza" className="block text-sm font-medium text-gray-700 mb-1">
              Inizio Decorrenza <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaCalendarAlt className="text-gray-400" />
              </span>
              <input
                type="date"
                id="inizio_decorrenza"
                name="inizio_decorrenza"
                value={policyData.inizio_decorrenza}
                onChange={handleInputChange}
                required
                min={minDateString} 
                max={maxDateString} 
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
              />
            </div>
          </div>

          {/* Fine Decorrenza */}
          <div>
            <label htmlFor="fine_decorrenza" className="block text-sm font-medium text-gray-700 mb-1">
              Fine Decorrenza <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaCalendarAlt className="text-gray-400" />
              </span>
              <input
                type="date"
                id="fine_decorrenza"
                name="fine_decorrenza"
                value={policyData.fine_decorrenza}
                onChange={handleInputChange}
                required
                disabled={!policyData.inizio_decorrenza} 
                min={minFineDateString} 
                max={maxFineDateString} 
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm disabled:bg-gray-100 disabled:cursor-not-allowed"
              />
            </div>
          </div>

          {/* Pacchetto Garanzia (Dropdown) */}
          <div>
            <label htmlFor="id_pacchetto_garanzia" className="block text-sm font-medium text-gray-700 mb-1">
              Pacchetto Garanzia <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaFileInvoice className="text-gray-400" />
              </span>
              <select
                id="id_pacchetto_garanzia"
                name="id_pacchetto_garanzia"
                value={policyData.id_pacchetto_garanzia}
                onChange={handleInputChange}
                required
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm appearance-none bg-white"
              >
                {pacchettiGaranziaOptions.length > 0 ? (
                  pacchettiGaranziaOptions.map(pkg => (
                    <option key={pkg.id} value={pkg.id}>
                      {pkg.nome} (€ {parseFloat(pkg.valore_base).toFixed(2)})
                    </option>
                  ))
                ) : (
                  <option value="">Nessun pacchetto garanzia disponibile</option>
                )}
              </select>
            </div>
          </div>

          {/* Valore Polizza Calcolato (Read-only) */}
          <div>
            <label htmlFor="valore_polizza_calcolato" className="block text-sm font-medium text-gray-700 mb-1">
              Valore Adesione Calcolato (€)
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <FaCalculator className="text-gray-400" />
              </span>
              <input
                type="text" 
                id="valore_polizza_calcolato"
                name="valore_polizza_calcolato"
                value={`€ ${parseFloat(policyData.valore_polizza_calcolato).toFixed(2)}`}
                readOnly
                disabled 
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none bg-gray-100 cursor-not-allowed sm:text-sm"
              />
            </div>
          </div>

          {/* Note */}
          <div>
            <label htmlFor="note" className="block text-sm font-medium text-gray-700 mb-1">
              Note
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3 pt-2 self-start"> 
                <FaStickyNote className="text-gray-400" />
              </span>
              <textarea
                id="note"
                name="note"
                value={policyData.note}
                onChange={handleInputChange}
                rows="3"
                className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-miorosso focus:border-miorosso sm:text-sm"
                placeholder="Aggiungi note sulla polizza..."
              ></textarea>
            </div>
          </div>

          {/* Messaggio di feedback temporaneo (altri avvisi generici) */}
          {feedbackMessage && (
            <div
              className={`p-3 rounded-md text-sm ${
                isErrorFeedback ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'
              }`}
              role="alert"
            >
              {feedbackMessage}
            </div>
          )}

          {/* Pulsanti di azione */}
          <div className="flex justify-end gap-3 pt-2">
            <button
              type="submit"
              disabled={isSubmitting || isLoading || !isTargaVerified} 
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-miorosso hover:bg-miorossohover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-miorosso disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isSubmitting ? (
                <>
                  <FaSpinner className="animate-spin -ml-1 mr-2 h-5 w-5" /> Creazione...
                </>
              ) : (
                <>
                  <FaSave className="mr-2 -ml-1 h-5 w-5" /> Salva Adesione
                </>
              )}
            </button>
          </div>
        </form>
      </div>

      {/* Modale di Conferma (per validazioni bloccanti o azioni di conferma) */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full text-center">
            <h3 className="text-xl font-bold mb-4 text-gray-800">{modalTitle}</h3>
            <p className="text-gray-700 whitespace-pre-line mb-6">{modalMessage}</p> 
            <div className="flex justify-center gap-4">
                {/* Se modalCallback è presente, mostra Annulla e OK per l'azione. Altrimenti, solo OK per chiudere. */}
                {modalCallback ? (
                  <>
                    <button
                        className="px-6 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400 transition-colors"
                        onClick={() => {
                            closeConfirmModal();
                            // Non chiamare resetForm qui, l'utente potrebbe voler continuare a modificare
                            // resetForm(); 
                        }}
                    >
                        Annulla
                    </button>
                    <button
                        className="px-6 py-2 bg-miorosso text-white rounded-md hover:bg-miorossohover transition-colors"
                        onClick={() => {
                            modalCallback(); // Esegue la callback principale
                            closeConfirmModal(); // Chiude la modale dopo l'esecuzione
                        }}
                    >
                        OK
                    </button>
                  </>
                ) : (
                  <div className="flex flex-col space-y-3 w-full">
  {justCreatedPolicy ? ( // Se una polizza è stata appena creata (per download PDF)
    <>
    <button
      className="w-full px-4 py-2 bg-mioblu text-white rounded-md hover:bg-miobluhover transition-colors text-sm"
      onClick={() => handleDownloadPdf(justCreatedPolicy)}
    >
      <FaFileInvoice className="inline mr-2" /> Scarica PDF Polizza
    </button>
    <button
      className="w-full px-4 py-2 bg-miorosso text-white rounded-md hover:bg-miorossohover transition-colors text-sm"
      onClick={() => {
        closeConfirmModal();
        resetForm();             // ✅ ora è sicuro resettare dopo la chiusura della modale
        setJustCreatedPolicy(null); // Pulisci lo stato dopo l'uso
      }}
    >
      OK
    </button>
    </>
  ) : ( // Se nessun polizza è stata appena creata (informazioni generali/avviso, come verifica targa)
    <button // Questo è il pulsante "OK" per le modali informative generali, NON deve resettare il form
      className="w-full px-4 py-2 bg-miorosso text-white rounded-md hover:bg-miorossohover transition-colors text-sm"
      onClick={() => {
        closeConfirmModal(); // SOLO chiudi la modale, non resettare il form
      }}
    >
      OK
    </button>
  )}
</div>

                )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
